import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import Header from "./Header";
import Sidebar from "./Sidebar";

const MainContent = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [wordText, setWordText] = useState(" WORLD!");

  const images = ["/Assets/01.jpg", "/Assets/02.jpg", "/Assets/03.jpg"];

  // GSAP setup for background image transitions
  const changeBackgroundImage = (index) => {
    gsap.to(".bgImage", {
      opacity: 0,
      scale: 1,
      duration: 1,
      ease: "power2.out",
      stagger: 0.1,
    });

    gsap.fromTo(
      `.bgImage:nth-child(${index + 1})`,
      { opacity: 0, scale: 1 },
      { opacity: 1, scale: 1.1, duration: 8, ease: "power2.inOut" }
    );
  };

  // Typing animation for the word "WORLD!"
  const eraseAndTypeAnimation = () => {
    const letters = wordText.split("");
    const wordElement = document.getElementById("animated-word");

    let index = letters.length;

    // Step 1: Erase letters one by one from the end
    const eraseInterval = setInterval(() => {
      if (index > 0) {
        wordElement.textContent = letters.slice(0, index - 1).join("");
        index--;
      } else {
        clearInterval(eraseInterval);
        index = 0;

        // Step 2: Type letters one by one from the beginning
        const typeInterval = setInterval(() => {
          if (index < letters.length) {
            wordElement.textContent += letters[index];
            index++;
          } else {
            clearInterval(typeInterval);
          }
        }, 150); // Typing speed
      }
    }, 100); // Erasing speed
  };

  // Initial animation and looping the effect
  useEffect(() => {
    const delayTypingStart = setTimeout(() => {
      eraseAndTypeAnimation(); // Start the typing animation after a delay
    }, 1000); // 1 second delay before starting typing

    // Loop the animation every 5 seconds
    const intervalId = setInterval(eraseAndTypeAnimation, 5000);

    return () => {
      clearTimeout(delayTypingStart);
      clearInterval(intervalId);
    };
  }, [wordText]); // Re-run effect only if wordText changes

  // Change image every 8 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 8000);
    return () => clearInterval(intervalId);
  }, []);

  // Trigger background image change when currentIndex changes
  useEffect(() => {
    changeBackgroundImage(currentIndex);
  }, [currentIndex]);

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
        <Sidebar />
         <Header />  
      {/* Background Images */}
      <div className="absolute inset-0 z-0">
        {images.map((image, index) => (
          <div
            key={index}
            className="bgImage absolute inset-0 bg-cover bg-center opacity-0"
            style={{ backgroundImage: `url(${image})` }}
          >
            {/* Black transparent overlay */}
            <div className="absolute inset-0 bg-black opacity-10"></div>
          </div>
        ))}
      </div>

      {/* Text Content */}
      <div className="relative z-10 text-white text-start pt-10 w-[100%] px-[10%]">
        <h1 className="text-[110px] font-bold text-white leading-tight">
          FROM PAKISTAN TO
          <br />
          THE {' '}
          <span
            id="animated-word"
            className="text-[#457b9d] inline-block"
          >
            {wordText}
          </span>
        </h1>

        <p className="mt-10 text-2xl">
          SocraticAli Consultants Your Digital Gateway to Global Education.
        </p>
        <div className="mt-10 space-x-4 md:pb-9">
          <button onClick={()=>{navigate('/signin')}} className="bg-[#457b9d] rounded-md text-white px-6 py-3 font-semibold hover:bg-[#1d3557] hover:text-white transition-all duration-300">
            BOOK FREE CONSULTATION
          </button>
          <a href="#calculate-cost" className="cursor-pointer border rounded-md border-white px-6 py-3 hover:bg-[#1d3557] hover:border-[#1d3557] hover:text-white transition-all duration-300">
            HOW MUCH DOES IT COST?
          </a>
        </div>
      </div>
    </section>
  );
};

export default MainContent;
